export default {
    MARKETING: "Маркетинг",
    UTILITY: "Сервисный",
    official_whatsapp: "WhatsApp (официальный)",
    official_whatsapp_template: "Шаблон официального WhatsApp",
    official_whatsapp_template_required: "Не выбран шаблон официального WhatsApp",
    official_whatsapp_templates: "Шаблоны официального WhatsApp",
    owa_buttons: "Кнопки быстрого ответа",
    owa_buttons_hint: "До 3 кнопок, каждая до 25 символов",
    owa_connect_failed: "Не удалось подключить номер. Нажмите кнопку ещё раз",
    owa_connect_hint: "Выберите существующий номер WhatsApp Business и на последнем шаге добавьте карту клиники: без неё напоминания не отправятся. Если карту забыли: business.facebook.com → портфолио клиники → Настройки → Счета и платежи → Аккаунты WhatsApp Business → Добавить способ оплаты",
    owa_connect_whatsapp: "Подключить WhatsApp",
    owa_connected_phone: "Подключено: {phone}",
    owa_connected_phone_of_branch: "Используется номер филиала «{branch}»: {phone}",
    owa_stop_using_branch: "Не использовать номер другого филиала",
    owa_use_branch_connection: "Использовать номер, подключённый в другом филиале",
    owa_use: "Использовать",
    owa_or_connect_own: "Или подключите для этого филиала свой номер:",
    owa_source_branch_disconnected: "Номер филиала «{branch}» отключён.",
    owa_disconnect_confirm: "Отправка через официальный WhatsApp будет остановлена. Продолжить?",
    owa_disconnect_instructions: "Отключите номер в приложении: WhatsApp Business → Настройки → Аккаунт → Бизнес-платформа → Отключить. Включайте текущий способ отправки только после этого: две системы на одном номере ведут к блокировке",
    owa_disconnected: "Отключено. Номер отключили в приложении или Meta отключила его после 14 дней без входа в WhatsApp Business. Подключите номер заново",
    owa_example_client: "Иванова Айгерим",
    owa_example_client_name: "Айгерим",
    owa_example_clinic: "Smile Factory",
    owa_example_doctor: "Петров Асхат",
    owa_examples: "Примеры значений",
    owa_examples_hint: "Нужны Meta для модерации шаблона, пациентам не отправляются",
    owa_facebook_not_loaded: "Не удалось загрузить окно Facebook. Обновите страницу",
    owa_official_mode_active: "В уведомлениях и рассылках выберите канал «WhatsApp (официальный)»: сообщения уйдут по одобренным шаблонам",
    owa_official_mode_after_approval: "Канал «WhatsApp (официальный)» отправляет сообщения только по одобренным шаблонам. Создайте шаблон:",
    owa_pending: "Подключение начато, но не завершено",
    owa_refresh_statuses: "Обновить статусы",
    owa_status_approved: "Одобрен",
    owa_status_disabled: "Отключён",
    owa_status_paused: "Приостановлен",
    owa_status_pending: "На проверке",
    owa_status_rejected: "Отклонён",
    owa_switch_to_current_way: "Вернуться на текущий способ отправки",
    owa_tags_for_template: "Теги для шаблона (в Meta уходят как пронумерованные переменные):",
    owa_template_hint: "Без медицинских деталей и рекламы; имя, дату и время указывайте тегами; текст не должен начинаться или заканчиваться тегом. Модерация занимает от нескольких минут до 24 часов, одобренный шаблон не редактируется",
    owa_template_select_hint: "В WhatsApp уйдёт выбранный шаблон",
    owa_templates_page_hint: "Новый шаблон создаётся для номера текущего филиала. Чтобы шаблон отправлялся из всех филиалов с отдельными номерами, создайте его для каждого номера с тем же именем в Meta. Использовать в уведомлениях и рассылках можно только одобренные шаблоны",
    owa_template_name: "Имя в Meta",
    owa_text_for_moderation: "Текст для модерации",
    owa_what_changes_1: "переписка один на один, контакты и история за 6 месяцев сохраняются",
    owa_what_changes_2: "связанные устройства отключатся: WhatsApp Web нужно привязать заново, приложение WhatsApp для Windows не поддерживается",
    owa_what_changes_3: "рассылки станут только для чтения, быстрые ответы, метки, приветствие и сообщение об отсутствии перестанут работать",
    owa_what_changes_4: "исчезающие сообщения и «просмотр один раз» отключаются, группы не синхронизируются",
    owa_what_changes_5: "приложение на телефоне нужно открывать хотя бы раз в 14 дней, иначе Meta отключит номер",
    owa_what_changes_title: "Что изменится в WhatsApp Business после подключения:",
    owa_purpose: "Для чего шаблон",
    owa_purpose_hint: "От назначения зависят доступные теги и где шаблон можно выбрать",
    owa_purpose_notifications: "Уведомления",
    owa_purpose_mailing: "Рассылки",
    owa_purpose_birthday: "Поздравления с днём рождения",
    owa_birthday_template_select_hint: "В WhatsApp уйдёт выбранный шаблон, остальные каналы получат текст ниже",
    owa_header: "Вложение",
    owa_header_hint: "Картинка, документ или видео уходит с каждым сообщением. В уведомлениях и рассылках это вложение уведомления или картинка рассылки: без него сообщение не отправится",
    owa_header_documents_hint: "К сообщению прикладывается PDF документа (квитанция, план лечения, наряд-заказ). Шаблон используется при отправке документов в WhatsApp; если одобренного шаблона нет, документ уходит без шаблона, только если пациент писал клинике последние 24 часа",
    owa_header_none: "Без вложения",
    owa_header_image: "Картинка",
    owa_header_document: "Документ",
    owa_header_video: "Видео",
    owa_header_example_hint: "Пример файла для модерации Meta: картинка JPG/PNG до 5 МБ, документ PDF/DOC/XLS/PPT/TXT или видео MP4 до 15 МБ",
    owa_example_document: "План лечения №12",
    owa_purpose_documents: "Документы",
    owa_purpose_links: "Ссылки",
    owa_subtype: "Документ / ссылка",
    owa_subtype_documents: "Документ",
    owa_subtype_links: "Ссылка",
    owa_subtype_hint: "Шаблон используется только при отправке выбранного документа или ссылки. Для каждого номера может быть один шаблон на проверке или одобренный",
    owa_subtype_receipt: "Квитанция об оплате",
    owa_subtype_treatment_plan: "План лечения",
    owa_subtype_laboratory_order: "Наряд-заказ в лабораторию",
    owa_subtype_anketa: "Анкета пациента",
    owa_subtype_visit_review: "Отзыв о визите",
    owa_template_with_header_hint: "К сообщению прикладывается вложение уведомления ({header}), без него сообщение не отправится",
    whatsapp_window_closed: "Пациент не писал клинике последние 24 часа: без шаблона сообщение не отправить. Создайте шаблон официального WhatsApp для документов или ссылок",
    whatsapp_attachment_not_suitable: "Вложение не подходит для шаблона официального WhatsApp: его нет, формат другой или файл слишком большой",
    owa_header_example: "Пример файла",
    owa_header_example_documents_hint: "Необязательно: если не загрузить файл, Meta получит пример PDF, сформированный автоматически",
}
